/* ============================================================
   Paso de pago directo en el drawer (#odis-pago).
   - Guarda los datos tributarios como attributes del carrito
     (shoppingcart-tags, RUT, razon, giro, direccion-facturacion), que llegan
     a la orden como note attributes.
   - Redirige al checkout con UN solo POST nativo a /cart (param checkout=1)
     con el prefill de dirección/contacto en la query (cart permalink params).
   - Dirección con Google PlaceAutocompleteElement restringido a Chile,
     con detección de número de calle faltante.
   - Persistencia en localStorage (clave `minicart_pago`) para que el
     cliente llene sus datos una sola vez.
   El panel vive FUERA de #CartDrawer: los re-renders del Section Rendering
   API no lo tocan. Eventos delegados en document por la misma razón.
   ============================================================ */
(function () {
  'use strict';

  var RAIZ = '#odis-pago';

  function $q(sel, root) { return (root || document).querySelector(sel); }
  function $qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function pq(sel) { return $q(RAIZ + ' ' + sel); }
  function pqa(sel) { return $qa(RAIZ + ' ' + sel); }
  function addC(el, c) { if (el) el.classList.add(c); }
  function rmC(el, c) { if (el) el.classList.remove(c); }
  function togC(el, c, on) { if (el) el.classList.toggle(c, !!on); }
  function visible(el) { return !!(el && el.getClientRects().length); }
  function val(sel) { var el = pq(sel); return el ? String(el.value || '').trim() : ''; }

  // ===== Config desde data attributes =====
  function raiz() { return $q(RAIZ); }

  function pago_config() {
    var r = raiz();
    if (!r) return {};
    try { return JSON.parse(r.dataset.pagoConfig || '{}'); } catch (e) { return {}; }
  }

  function pago_rut_obligatorio(doctype) {
    var cfg = pago_config();
    return doctype === 'factura' ? cfg.facturaRut !== false : cfg.boletaRut === true;
  }

  function pago_direccion_obligatoria(doctype) {
    var cfg = pago_config();
    return doctype === 'factura' ? cfg.facturaDireccion === true : cfg.boletaDireccion === true;
  }

  // ===== Persistencia local =====
  function pago_storage_leer() {
    try { return JSON.parse(localStorage.getItem('minicart_pago') || 'null'); } catch (e) { return null; }
  }

  function pago_storage_guardar(cambios) {
    try {
      var st = pago_storage_leer() || {};
      Object.keys(cambios).forEach(function (k) { st[k] = cambios[k]; });
      localStorage.setItem('minicart_pago', JSON.stringify(st));
    } catch (e) {}
  }

  // ===== Validadores =====
  function validar_rut(valor) {
    valor = String(valor || '').replace(/\./g, '').replace(/-/g, '').trim();
    if (!valor) return null;
    var cuerpo = valor.slice(0, -1);
    var dv = valor.slice(-1).toUpperCase();
    var formateado = cuerpo + '-' + dv;
    if (cuerpo.length < 7 || !/^\d+$/.test(cuerpo)) return { ok: false, formateado: formateado };
    var suma = 0, multiplo = 2;
    for (var i = 1; i <= cuerpo.length; i++) {
      suma += multiplo * parseInt(valor.charAt(cuerpo.length - i), 10);
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }
    var dvEsperado = 11 - (suma % 11);
    var dvNum;
    if (dv === 'K') dvNum = 10;
    else if (dv === '0') dvNum = 11;
    else dvNum = parseInt(dv, 10);
    if (isNaN(dvNum)) return { ok: false, formateado: formateado };
    return { ok: dvEsperado === dvNum, formateado: formateado };
  }

  function validar_correo(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());
  }

  function validar_telefono(v) {
    var digitos = String(v).replace(/\D/g, '');
    return digitos.length >= 8 && digitos.length <= 15;
  }

  function validar_rut_input(el) {
    if (!el) return;
    var msg = el.parentElement ? el.parentElement.querySelector('.rut-msg') : null;
    var limpio = el.value.replace(/\./g, '').replace(/-/g, '').trim();
    if (limpio.length < 2) {
      rmC(el, 'valido'); rmC(el, 'invalido'); rmC(msg, 'show');
      return;
    }
    var r = validar_rut(el.value);
    el.value = r.formateado;
    togC(el, 'valido', r.ok);
    togC(el, 'invalido', !r.ok);
    if (!r.ok && msg) msg.textContent = 'El RUT no es válido';
    togC(msg, 'show', !r.ok);
  }

  function fmt_money_mini(cents) {
    cents = parseInt(cents, 10) || 0;
    var s = cents.toString();
    s = s.length > 2 ? s.substring(0, s.length - 2) : '0';
    return s.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
  }

  // ===== Google Places =====
  function cargar_google_places(key) {
    if (window.__gplacesPromise) return window.__gplacesPromise;
    window.__gplacesPromise = new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('Google Maps timeout')); }, 8000);
      window.__gplacesReady = function () { clearTimeout(timer); resolve(); };
      var s = document.createElement('script');
      s.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) +
              '&v=weekly&loading=async&callback=__gplacesReady';
      s.async = true;
      s.onerror = function () { clearTimeout(timer); reject(new Error('No se pudo cargar Google Maps')); };
      document.head.appendChild(s);
    });
    return window.__gplacesPromise;
  }

  function montar_widget(slotSel, placeholder, alSeleccionar, alFallar) {
    var slot = pq(slotSel);
    if (!slot || slot.dataset.ready) return;
    var key = String(raiz().dataset.placesKey || '').trim();
    if (!key) { slot.dataset.ready = 'off'; alFallar(); return; }
    slot.dataset.ready = 'loading';
    cargar_google_places(key)
      .then(function () { return google.maps.importLibrary('places'); })
      .then(function (lib) {
        var el = new lib.PlaceAutocompleteElement();
        el.includedRegionCodes = ['cl'];
        el.placeholder = placeholder;
        el.noInputIcon = true;
        slot.appendChild(el);
        el.addEventListener('gmp-select', function (ev) {
          var place = ev.placePrediction.toPlace();
          place.fetchFields({ fields: ['addressComponents', 'formattedAddress'] }).then(function () {
            alSeleccionar(place);
          }).catch(function () { /* sin detalles: seguimos sin dirección */ });
        });
        slot.dataset.ready = 'google';
      })
      .catch(function () {
        slot.dataset.ready = 'error';
        alFallar();
      });
  }

  function init_direccion_google() {
    montar_widget('.direccion-slot', 'Dirección de despacho', function (place) {
      var texto = place.formattedAddress || 'Dirección seleccionada';
      window.miniCartDireccion = parse_place_direccion(place);
      mostrar_direccion_ui(texto);
      pago_storage_guardar({ dir: window.miniCartDireccion, dirTexto: texto });
    }, function () {
      var campo = pq('.campo-direccion'); if (campo) campo.style.display = 'none';
      var depto = pq('.campo-depto'); if (depto) depto.style.display = 'none';
      var fact = pq('.campo-fact-dir'); if (fact) fact.style.display = 'none';
      actualizar_barra_envio();
    });
  }

  function init_direccion_google_fact() {
    montar_widget('.fact-slot', 'Dirección de facturación', function (place) {
      var texto = place.formattedAddress || 'Dirección seleccionada';
      window.miniCartDirFact = parse_place_direccion(place);
      mostrar_fact_ui(texto);
      pago_storage_guardar({ dirFact: window.miniCartDirFact, dirFactTexto: texto });
    }, function () {
      var campo = pq('.campo-fact-dir'); if (campo) campo.style.display = 'none';
    });
  }

  function parse_place_direccion(place) {
    var comp = {};
    (place.addressComponents || []).forEach(function (c) {
      (c.types || []).forEach(function (t) { comp[t] = c.longText; });
    });
    var comuna = comp['locality'] || comp['administrative_area_level_3'] || comp['sublocality_level_1'] || '';
    return {
      route: comp['route'] || '',
      numero: comp['street_number'] || '',
      sinNumero: false,
      city: comuna,
      provinceCode: region_a_codigo(comp['administrative_area_level_1'] || ''),
      zip: comp['postal_code'] || ''
    };
  }

  function region_a_codigo(nombre) {
    var n = String(nombre || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    var mapa = [
      ['metropolitana', 'RM'], ['valparais', 'VS'], ['higgins', 'LI'], ['maule', 'ML'],
      ['nuble', 'NB'], ['biobio', 'BI'], ['araucania', 'AR'], ['los rios', 'LR'],
      ['los lagos', 'LL'], ['aysen', 'AI'], ['magallanes', 'MA'], ['arica', 'AP'],
      ['tarapaca', 'TA'], ['antofagasta', 'AN'], ['atacama', 'AT'], ['coquimbo', 'CO']
    ];
    for (var i = 0; i < mapa.length; i++) {
      if (n.indexOf(mapa[i][0]) !== -1) return mapa[i][1];
    }
    return '';
  }

  // ===== Estado de dirección =====
  function direccion_address1(dir) {
    if (!dir) return '';
    var route = dir.route || dir.address1 || '';
    if (!route) return '';
    if (dir.numero) return (route + ' ' + dir.numero).trim();
    if (dir.sinNumero) return (route + ' S/N').trim();
    return route.trim();
  }

  function direccion_falta_numero(dir) {
    return !!(dir && dir.route && !dir.numero && !dir.sinNumero);
  }

  function direccion_completa(dir) {
    if (!dir) return false;
    if (direccion_falta_numero(dir)) return false;
    return !!(dir.route || dir.address1);
  }

  function mostrar_direccion_ui(texto, esGuardada) {
    var dir = window.miniCartDireccion;
    var slot = pq('.direccion-slot');
    var guardada = pq('.direccion-guardada');
    var cont = pq('.direccion-numero');
    var ok = pq('.direccion-ok');
    var completa = direccion_completa(dir);
    var falta = direccion_falta_numero(dir);

    if (esGuardada && completa) {
      var t = guardada && guardada.querySelector('.texto');
      if (t) t.textContent = texto;
      addC(guardada, 'show');
      addC(slot, 'oculto');
      rmC(ok, 'show');
      rmC(cont, 'show');
      actualizar_barra_envio();
      return;
    }

    rmC(guardada, 'show');
    rmC(slot, 'oculto');
    togC(slot, 'valido', completa);
    togC(slot, 'invalido', falta);
    if (dir) rmC(pq('.direccion-msg'), 'show');
    if (completa && ok) { ok.textContent = '✓ ' + texto; addC(ok, 'show'); }
    else rmC(ok, 'show');
    if (dir && dir.route && !dir.numero) {
      var chk = $q('#minicart-sin-numero');
      if (chk) chk.checked = !!dir.sinNumero;
      togC(cont, 'sin', !!dir.sinNumero);
      addC(cont, 'show');
    } else {
      rmC(cont, 'show');
    }
    actualizar_barra_envio();
  }

  function actualizar_direccion_texto() {
    var dir = window.miniCartDireccion;
    if (!dir) return;
    var texto = direccion_address1(dir) + (dir.city ? ', ' + dir.city : '');
    rmC(pq('.direccion-msg'), 'show');
    var ok = pq('.direccion-ok');
    if (direccion_completa(dir) && ok) { ok.textContent = '✓ ' + texto; addC(ok, 'show'); }
    else rmC(ok, 'show');
    var slot = pq('.direccion-slot');
    togC(slot, 'valido', direccion_completa(dir));
    togC(slot, 'invalido', direccion_falta_numero(dir));
    pago_storage_guardar({ dir: dir, dirTexto: texto });
    actualizar_barra_envio();
  }

  // ===== Dirección de facturación (mirror) =====
  function mostrar_fact_ui(texto, esGuardada) {
    var dir = window.miniCartDirFact;
    var slot = pq('.fact-slot');
    var guardada = pq('.fact-guardada');
    var cont = pq('.fact-numero');
    var ok = pq('.fact-ok');
    var completa = direccion_completa(dir);
    var falta = direccion_falta_numero(dir);

    if (esGuardada && completa) {
      var t = guardada && guardada.querySelector('.texto');
      if (t) t.textContent = texto;
      addC(guardada, 'show');
      addC(slot, 'oculto');
      rmC(ok, 'show');
      rmC(cont, 'show');
      return;
    }

    rmC(guardada, 'show');
    rmC(slot, 'oculto');
    togC(slot, 'valido', completa);
    togC(slot, 'invalido', falta);
    if (dir) rmC(pq('.fact-msg'), 'show');
    if (completa && ok) { ok.textContent = '✓ ' + texto; addC(ok, 'show'); }
    else rmC(ok, 'show');
    if (dir && dir.route && !dir.numero) {
      var chk = $q('#minicart-fact-sin-numero');
      if (chk) chk.checked = !!dir.sinNumero;
      togC(cont, 'sin', !!dir.sinNumero);
      addC(cont, 'show');
    } else {
      rmC(cont, 'show');
    }
  }

  function actualizar_fact_texto() {
    var dir = window.miniCartDirFact;
    if (!dir) return;
    var texto = direccion_address1(dir) + (dir.city ? ', ' + dir.city : '');
    rmC(pq('.fact-msg'), 'show');
    var ok = pq('.fact-ok');
    if (direccion_completa(dir) && ok) { ok.textContent = '✓ ' + texto; addC(ok, 'show'); }
    else rmC(ok, 'show');
    var slot = pq('.fact-slot');
    togC(slot, 'valido', direccion_completa(dir));
    togC(slot, 'invalido', direccion_falta_numero(dir));
    pago_storage_guardar({ dirFact: dir, dirFactTexto: texto });
  }

  // ===== Barra de envío gratis (umbral por región) =====
  var odisCartTotal = 0;
  var pintando = false;

  function refrescar_total_carrito() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        odisCartTotal = cart.total_price || 0;
        aplicar_modo_retiro(cart.attributes);
        pintando = true;
        pintar_cupon(cart);
        actualizar_barra_envio();
        setTimeout(function () { pintando = false; }, 150);
        return cart;
      })
      .catch(function () { return null; });
  }

  // Texto de la barra sin direccion: configurable en el theme editor.
  // Si el texto contiene "envio gratis", esa frase va en negrita.
  function neutro_html(txt) {
    if (!txt) return '¿Tu compra califica para <strong>envío gratis</strong>?';
    var esc = txt.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return esc.replace(/env[ií]o gratis/i, function (m) { return '<strong>' + m + '</strong>'; });
  }

  function actualizar_barra_envio() {
    var barras = $qa('.envio-barra, .envio-badge');
    if (!barras.length) return;
    var slot = pq('.direccion-slot');
    var mslot = $q('.dir-modal .modal-slot');
    var sinGoogle = (slot && (slot.dataset.ready === 'off' || slot.dataset.ready === 'error')) ||
      (mslot && (mslot.dataset.ready === 'off' || mslot.dataset.ready === 'error'));
    // Dirección: la de la sesión, o la guardada en el navegador como fallback
    if (!window.miniCartDireccion) {
      var st = pago_storage_leer();
      if (st && st.dir) window.miniCartDireccion = st.dir;
    }
    var dir = window.miniCartDireccion;
    var r = raiz();
    // Umbrales activables por zona: sin umbral activo para la zona del
    // cliente no se promete envio gratis (la barra se oculta)
    var cfgEl = $q('#CartDrawer .envio-badge') || r;
    function zona_activa(nombre) {
      if (!cfgEl || cfgEl.dataset[nombre] === undefined) return true;
      return cfgEl.dataset[nombre] !== '0';
    }
    var rmActivo = zona_activa('umbralRmActivo');
    var regionesActivo = zona_activa('umbralRegionesActivo');
    var textoNeutro = (cfgEl && cfgEl.dataset.textoNeutro) || '';
    // En el badge la comuna es clickeable: abre el modal para cambiar la dirección
    var lapiz = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M12 20h9'/><path d='M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z'/></svg>";
    barras.forEach(function (barra) {
      if (sinGoogle || (!rmActivo && !regionesActivo)) { barra.style.display = 'none'; return; }
      barra.style.display = '';
      var msg = barra.querySelector('.msg');
      var fill = barra.querySelector('.envio-fill');
      var cta = barra.querySelector('.dir-cta');
      var esBadge = barra.classList.contains('envio-badge');
      rmC(barra, 'neutro');
      rmC(barra, 'completo');

      if (!dir || !(dir.provinceCode || dir.route || dir.address1)) {
        addC(barra, 'neutro');
        if (msg) msg.innerHTML = esBadge ? neutro_html(textoNeutro) : 'Ingresa tu dirección y descubre cuánto te falta para el envío gratis';
        if (fill) fill.style.width = '0%';
        if (cta) cta.style.display = '';
        return;
      }
      if (cta) cta.style.display = 'none';

      var lugar = '';
      if (dir.city) {
        lugar = esBadge
          ? ' a <a class="cambiar-comuna" role="button" tabindex="0" title="Cambiar dirección">' + dir.city + lapiz + '</a>'
          : ' a <strong>' + dir.city + '</strong>';
      }
      var esRM = dir.provinceCode === 'RM';
      if (esRM ? !rmActivo : !regionesActivo) { barra.style.display = 'none'; return; }
      var clave = esRM ? 'umbralRm' : 'umbralRegiones';
      var umbralPesos = parseInt(barra.dataset[clave] || (r ? r.dataset[clave] : ''), 10) || (esRM ? 30000 : 60000);
      var umbral = umbralPesos * 100;
      var total = odisCartTotal || 0;

      if (total >= umbral) {
        addC(barra, 'completo');
        if (msg) msg.innerHTML = '¡Tienes envío gratis' + lugar + '!';
        if (fill) fill.style.width = '100%';
      } else {
        var pct = Math.max(4, Math.round(total / umbral * 100));
        if (msg) msg.innerHTML = 'Te faltan <strong>$' + fmt_money_mini(umbral - total) + '</strong> para envío gratis' + lugar;
        if (fill) fill.style.width = pct + '%';
      }
    });
  }

  // ===== Modal de dirección (badge de envío del paso 1) =====
  // Mismo widget y almacenamiento que el paso de pago: la dirección que se
  // ingresa aquí llega prellenada al paso de pago y viceversa.
  function modal_el(sel) { return $q('.dir-modal' + (sel ? ' ' + sel : '')); }

  function mostrar_modal_ui() {
    if (!modal_el('')) return;
    var dir = window.miniCartDireccion;
    var ok = modal_el('.modal-ok');
    var cont = modal_el('.modal-numero');
    var chk = $q('#minicart-modal-sin-numero');
    if (dir && direccion_completa(dir)) {
      if (ok) {
        ok.textContent = '✓ ' + direccion_address1(dir) + (dir.city ? ', ' + dir.city : '');
        addC(ok, 'show');
      }
    } else {
      rmC(ok, 'show');
    }
    if (dir && dir.route && !dir.numero) {
      if (chk) chk.checked = !!dir.sinNumero;
      togC(cont, 'sin', !!dir.sinNumero);
      addC(cont, 'show');
    } else {
      rmC(cont, 'show');
    }
  }

  function init_direccion_google_modal() {
    var slot = modal_el('.modal-slot');
    if (!slot || slot.dataset.ready) return;
    var modal = modal_el('');
    var r = raiz();
    var key = String((modal && modal.dataset.placesKey) || (r && r.dataset.placesKey) || '').trim();
    if (!key) { slot.dataset.ready = 'off'; return; }
    slot.dataset.ready = 'loading';
    cargar_google_places(key)
      .then(function () { return google.maps.importLibrary('places'); })
      .then(function (lib) {
        var el = new lib.PlaceAutocompleteElement();
        el.includedRegionCodes = ['cl'];
        el.placeholder = 'Dirección de despacho';
        el.noInputIcon = true;
        slot.appendChild(el);
        el.addEventListener('gmp-select', function (ev) {
          var place = ev.placePrediction.toPlace();
          place.fetchFields({ fields: ['addressComponents', 'formattedAddress'] }).then(function () {
            var texto = place.formattedAddress || 'Dirección seleccionada';
            window.miniCartDireccion = parse_place_direccion(place);
            var chk = $q('#minicart-modal-sin-numero');
            if (chk) chk.checked = false;
            pago_storage_guardar({ dir: window.miniCartDireccion, dirTexto: texto });
            mostrar_direccion_ui(texto);
            mostrar_modal_ui();
            actualizar_barra_envio();
          }).catch(function () { /* sin detalles: seguimos sin dirección */ });
        });
        slot.dataset.ready = 'google';
      })
      .catch(function () {
        slot.dataset.ready = 'error';
        cerrar_dir_modal();
        actualizar_barra_envio();
      });
  }

  function abrir_dir_modal() {
    var modal = modal_el('');
    if (!modal) return;
    init_direccion_google_modal();
    var slot = modal_el('.modal-slot');
    if (slot && slot.dataset.ready === 'off') { actualizar_barra_envio(); return; }
    if (!window.miniCartDireccion) {
      var st = pago_storage_leer();
      if (st && st.dir) window.miniCartDireccion = st.dir;
    }
    mostrar_modal_ui();
    addC(modal, 'show');
    modal.setAttribute('aria-hidden', 'false');
    setTimeout(function () {
      try { $q('.dir-modal .modal-slot gmp-place-autocomplete').focus(); } catch (e) {}
    }, 250);
  }

  function cerrar_dir_modal() {
    var modal = modal_el('');
    if (!modal) return;
    rmC(modal, 'show');
    modal.setAttribute('aria-hidden', 'true');
  }

  // ===== Abrir / cerrar el paso =====
  function actualizar_doctype_ui(doctype) {
    togC(raiz(), 'factura', doctype === 'factura');
    var rut = $q('#minicart-rut');
    if (rut) rut.placeholder = pago_rut_obligatorio(doctype) ? 'RUT' : 'RUT (opcional)';
    if (doctype === 'factura') {
      var chk = $q('#minicart-misma-dir');
      if ((chk && !chk.checked) || es_retiro()) init_direccion_google_fact();
    }
  }

  function marcar_llenos() {
    ['#minicart-razon', '#minicart-giro', '#minicart-depto', '#minicart-nombre', '#minicart-apellido'].forEach(function (sel) {
      var el = $q(sel);
      if (el) togC(el, 'valido', el.value.trim().length > 0);
    });
    ['#minicart-correo', '#minicart-telefono'].forEach(function (sel) {
      var el = $q(sel);
      if (!el) return;
      var v = el.value.trim();
      var ok = sel === '#minicart-correo' ? validar_correo(v) : validar_telefono(v);
      togC(el, 'valido', v.length > 0 && ok);
    });
  }

  // ===== Modo retiro en tienda =====
  // Una app de despacho dentro del panel (en el ancla .app-anclaje) escribe el
  // metodo elegido como atributo del carrito. Si ese atributo indica retiro,
  // los campos de direccion de despacho se ocultan y no se validan. Atributo y
  // valores son configurables, asi el mecanismo no depende de una app puntual.
  function retiro_config() {
    var r = raiz();
    if (!r || r.dataset.retiroActivo === '0') return null;
    var valores = String(r.dataset.retiroValores || 'Pick Up').split(',')
      .map(function (v) { return v.trim().toLowerCase(); })
      .filter(Boolean);
    return { atributo: r.dataset.retiroAtributo || 'Delivery Method', valores: valores };
  }

  function es_retiro() {
    var r = raiz();
    return !!(r && r.classList.contains('retiro'));
  }

  function aplicar_modo_retiro(attrs) {
    var cfg = retiro_config();
    var r = raiz();
    if (!r) return;
    var activo = false;
    if (cfg) {
      var v = String((attrs || {})[cfg.atributo] || '').trim().toLowerCase();
      activo = cfg.valores.indexOf(v) !== -1;
    }
    if (activo === es_retiro()) return;
    togC(r, 'retiro', activo);
    if (activo) {
      rmC(pq('.direccion-msg'), 'show');
      rmC(pq('.direccion-numero'), 'show');
      var fact = $q('#minicart-factura');
      if (fact && fact.checked) init_direccion_google_fact();
    }
  }

  var retiroTimers = [];
  function revisar_retiro() {
    if (!retiro_config()) return;
    retiroTimers.forEach(clearTimeout);
    retiroTimers = [150, 1200].map(function (ms) {
      return setTimeout(function () {
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) { aplicar_modo_retiro(cart.attributes); })
          .catch(function () {});
      }, ms);
    });
  }

  // Las apps escriben el metodo elegido con /cart/update; se escucha esa
  // escritura (fetch o XHR) en vez de los clicks en su widget, que puede
  // cambiar de markup o de ubicacion
  function es_escritura_carrito(url) {
    return /\/cart\/(update|change)(\.js)?/.test(String(url || ''));
  }

  (function escuchar_escrituras_carrito() {
    if (window.__odisRetiroHook) return;
    window.__odisRetiroHook = true;
    if (window.fetch) {
      var fetchOriginal = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url);
        var p = fetchOriginal.apply(this, arguments);
        if (es_escritura_carrito(url)) {
          p.then(function () { revisar_retiro(); }).catch(function () {});
        }
        return p;
      };
    }
    var openOriginal = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (es_escritura_carrito(url)) {
        this.addEventListener('loadend', function () { revisar_retiro(); });
      }
      return openOriginal.apply(this, arguments);
    };
  })();

  function abrir_pago_step() {
    var step = raiz();
    if (!step) { window.location.href = '/cart'; return; }
    revisar_retiro();

    var st = pago_storage_leer() || {};
    var boleta = $q('#minicart-boleta');
    if (boleta) boleta.checked = true;
    actualizar_doctype_ui('boleta');

    var campos = { rut: '#minicart-rut', razon: '#minicart-razon', giro: '#minicart-giro', depto: '#minicart-depto', nombre: '#minicart-nombre', apellido: '#minicart-apellido', correo: '#minicart-correo', telefono: '#minicart-telefono' };
    Object.keys(campos).forEach(function (k) {
      var el = $q(campos[k]);
      if (el && st[k] && !el.value) el.value = st[k];
    });
    var rutEl = $q('#minicart-rut');
    if (rutEl && rutEl.value) validar_rut_input(rutEl);
    marcar_llenos();

    if (!window.miniCartDireccion && st.dir) window.miniCartDireccion = st.dir;
    if (window.miniCartDireccion) {
      var dirAct = window.miniCartDireccion;
      var textoDir = st.dirTexto || (direccion_address1(dirAct) + (dirAct.city ? ', ' + dirAct.city : ''));
      mostrar_direccion_ui(textoDir, true);
    }
    var factMisma = st.factMisma !== false;
    var mismaChk = $q('#minicart-misma-dir');
    if (mismaChk) mismaChk.checked = factMisma;
    togC(pq('.campo-fact-dir'), 'distinta', !factMisma);
    if (!window.miniCartDirFact && st.dirFact) {
      window.miniCartDirFact = st.dirFact;
      mostrar_fact_ui(st.dirFactTexto || 'Usaremos tu dirección anterior', true);
    }

    limpiar_pago_errores();
    addC(step, 'show');
    step.setAttribute('aria-hidden', 'false');
    init_direccion_google();
    refrescar_total_carrito();
  }

  function cerrar_pago_step() {
    var step = raiz();
    if (!step) return;
    rmC(step, 'show');
    step.setAttribute('aria-hidden', 'true');
  }

  // ===== Errores =====
  function limpiar_pago_errores() {
    rmC(pq('.pago-error'), 'show');
    pqa('.campo-error').forEach(function (el) { rmC(el, 'show'); });
    ['#minicart-razon', '#minicart-giro'].forEach(function (sel) { rmC($q(sel), 'invalido'); });
  }

  function pago_shake() {
    var step = raiz();
    addC(step, 'shake');
    setTimeout(function () { rmC(step, 'shake'); }, 500);
  }

  // ===== Continuar al pago (POST atómico) =====
  function continuar_pago() {
    var doctypeEl = $q(RAIZ + ' input[name="minicart_doctype"]:checked');
    var doctype = doctypeEl ? doctypeEl.value : 'boleta';
    var rutRaw = val('#minicart-rut');
    var razon = val('#minicart-razon');
    var giro = val('#minicart-giro');
    var cfg = pago_config();
    var esFactura = doctype === 'factura';
    var rutInfo = validar_rut(rutRaw);

    limpiar_pago_errores();

    var foco = null;
    var dir = window.miniCartDireccion;
    var correo = val('#minicart-correo');
    var telefono = val('#minicart-telefono');

    function marcarError(msgSel, inputSel, texto) {
      var m = pq(msgSel);
      if (m) { if (texto) m.textContent = texto; addC(m, 'show'); }
      if (inputSel) addC($q(inputSel), 'invalido');
    }

    if (correo && !validar_correo(correo)) {
      marcarError('.correo-msg', '#minicart-correo');
      foco = foco || '#minicart-correo';
    }
    if (!rutInfo && pago_rut_obligatorio(doctype)) {
      marcarError('.campo-rut .rut-msg', '#minicart-rut', esFactura ? 'Ingresa un RUT válido para tu factura' : 'Ingresa tu RUT');
      foco = foco || '#minicart-rut';
    } else if (rutInfo && !rutInfo.ok) {
      marcarError('.campo-rut .rut-msg', '#minicart-rut', 'El RUT ingresado no es válido');
      foco = foco || '#minicart-rut';
    }
    if (esFactura) {
      if (cfg.facturaRazon !== false && !razon) {
        marcarError('.razon-msg', '#minicart-razon');
        foco = foco || '#minicart-razon';
      }
      if (cfg.facturaGiro !== false && !giro) {
        marcarError('.giro-msg', '#minicart-giro');
        foco = foco || '#minicart-giro';
      }
    }
    if (es_retiro()) {
      // retiro en tienda: la direccion de despacho no aplica
    } else if (direccion_falta_numero(dir)) {
      addC(pq('.direccion-numero'), 'show');
      foco = foco || '#minicart-sin-numero';
    } else if (pago_direccion_obligatoria(doctype) && !direccion_completa(dir) && visible(pq('.campo-direccion'))) {
      marcarError('.direccion-msg', null);
      addC(pq('.direccion-slot'), 'invalido');
    }
    var mismaChk = $q('#minicart-misma-dir');
    var mismaDir = (mismaChk ? mismaChk.checked : true) && !es_retiro();
    var dirFact = window.miniCartDirFact;
    var factDistinta = esFactura && !mismaDir && visible(pq('.fact-dir-cont'));
    if (factDistinta) {
      if (direccion_falta_numero(dirFact)) {
        addC(pq('.fact-numero'), 'show');
        foco = foco || '#minicart-fact-sin-numero';
      } else if (!direccion_completa(dirFact)) {
        marcarError('.fact-msg', null);
        addC(pq('.fact-slot'), 'invalido');
      }
    }
    if (telefono && !validar_telefono(telefono)) {
      marcarError('.telefono-msg', '#minicart-telefono');
      foco = foco || '#minicart-telefono';
    }
    var terminos = $q('#minicart-terminos');
    if (terminos && !terminos.checked) {
      marcarError('.terminos-msg', null);
      foco = foco || '#minicart-terminos';
    }

    var hayError = pqa('.campo-error.show').some(visible) ||
      pqa('.direccion-numero.show:not(.sin)').some(visible) ||
      pqa('.fact-numero.show:not(.sin)').some(visible);
    if (hayError) {
      if (foco) { var f = $q(foco); if (f) f.focus(); }
      pago_shake();
      return;
    }

    rmC(pq('.pago-error'), 'show');
    addC(raiz(), 'loading');

    var rutFinal = rutInfo && rutInfo.ok ? rutInfo.formateado : '';
    var depto = val('#minicart-depto');
    var nombre = val('#minicart-nombre');
    var apellido = val('#minicart-apellido');
    pago_storage_guardar({
      rut: rutFinal,
      razon: esFactura ? razon : '',
      giro: esFactura ? giro : '',
      depto: depto,
      nombre: nombre,
      apellido: apellido,
      correo: correo,
      telefono: telefono,
      factMisma: mismaDir
    });

    var params = ['checkout[shipping_address][country]=CL'];
    // Campos visibles = fuente de verdad: se envían siempre, vacíos incluidos
    if ($q('#minicart-correo')) params.push('checkout[email]=' + encodeURIComponent(correo));
    if ($q('#minicart-nombre')) {
      params.push('checkout[shipping_address][first_name]=' + encodeURIComponent(nombre));
      params.push('checkout[shipping_address][last_name]=' + encodeURIComponent(apellido));
    }
    if ($q('#minicart-telefono')) params.push('checkout[shipping_address][phone]=' + encodeURIComponent(telefono));
    params.push('checkout[shipping_address][company]=' + encodeURIComponent(rutFinal));
    if (dir) {
      var addr1 = direccion_address1(dir);
      if (addr1) params.push('checkout[shipping_address][address1]=' + encodeURIComponent(addr1));
      if ($q('#minicart-depto')) params.push('checkout[shipping_address][address2]=' + encodeURIComponent(depto));
      if (dir.city) params.push('checkout[shipping_address][city]=' + encodeURIComponent(dir.city));
      if (dir.provinceCode) params.push('checkout[shipping_address][province]=' + encodeURIComponent(dir.provinceCode));
      if (dir.zip) params.push('checkout[shipping_address][zip]=' + encodeURIComponent(dir.zip));
    }
    var dirFactStr = '';
    if (factDistinta && direccion_completa(dirFact)) {
      var factAddr1 = direccion_address1(dirFact);
      params.push('checkout[billing_address][country]=CL');
      if (factAddr1) params.push('checkout[billing_address][address1]=' + encodeURIComponent(factAddr1));
      if (dirFact.city) params.push('checkout[billing_address][city]=' + encodeURIComponent(dirFact.city));
      if (dirFact.provinceCode) params.push('checkout[billing_address][province]=' + encodeURIComponent(dirFact.provinceCode));
      if (dirFact.zip) params.push('checkout[billing_address][zip]=' + encodeURIComponent(dirFact.zip));
      if (rutFinal) params.push('checkout[billing_address][company]=' + encodeURIComponent(rutFinal));
      dirFactStr = factAddr1;
      if (dirFact.city) dirFactStr += ', ' + dirFact.city;
      if (dirFact.zip) dirFactStr += ', ' + dirFact.zip;
    }

    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart?' + params.join('&');
    var campos = {
      'attributes[shoppingcart-tags]': doctype,
      'attributes[RUT]': rutFinal,
      'attributes[razon]': esFactura ? razon : '',
      'attributes[giro]': esFactura ? giro : '',
      'attributes[direccion-facturacion]': dirFactStr,
      'checkout': '1'
    };
    Object.keys(campos).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = campos[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  // ===== Cupón de descuento (drawer, paso 1) =====
  function cupon_el(sel) { return $q('#CartDrawer ' + sel); }

  function cupon_msg(tipo, texto) {
    var el = cupon_el('.cupon-' + tipo);
    if (el) { el.textContent = texto; addC(el, 'show'); }
    if (tipo === 'error') {
      var cupon = cupon_el('.cupon');
      if (cupon && !cupon.classList.contains('open')) addC(cupon, 'open');
      var fila = cupon_el('.cupon .fila');
      addC(fila, 'shake');
      setTimeout(function () { rmC(fila, 'shake'); }, 500);
    }
  }

  function pintar_cupon(cart) {
    var pills = cupon_el('.cupon-pills');
    if (!pills) return;
    var aplicados = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
    window.odisCupones = aplicados.map(function (d) { return d.code; });
    pills.innerHTML = aplicados.map(function (d) {
      var codigo = String(d.code).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
      return '<li data-code="' + codigo + '"><span>' + codigo + '</span><i class="quitar" role="button" tabindex="0" title="Quitar cupón"></i></li>';
    }).join('');
    togC(cupon_el('.cupon'), 'has-pills', aplicados.length > 0);
  }

  // Re-renderiza el drawer con el Section Rendering API (precios y totales al día)
  function refrescar_drawer() {
    var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    return fetch(base + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var doc = new DOMParser().parseFromString(data['cart-drawer'] || '', 'text/html');
        var nuevo = doc.querySelector('#CartDrawer');
        var actual = $q('#CartDrawer');
        if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
        var cdNuevo = doc.querySelector('cart-drawer');
        var cd = $q('cart-drawer');
        if (cd && cdNuevo) togC(cd, 'is-empty', cdNuevo.classList.contains('is-empty'));
        return refrescar_total_carrito();
      })
      .catch(function () { return refrescar_total_carrito(); });
  }

  function post_cupones(codigos) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'discount=' + encodeURIComponent(codigos.join(','))
    }).then(function (r) {
      // Una respuesta HTML (p. ej. redirigido a una pagina de
      // login/contrasena porque la sesion expiro) no debe tratarse como
      // "cupon invalido": se avisa que hay que recargar. El endpoint
      // responde application/javascript, no application/json
      var tipo = (r.headers.get('content-type') || '');
      if (!r.ok || tipo.indexOf('html') !== -1) {
        var err = new Error('respuesta no valida');
        err.sesionExpirada = true;
        throw err;
      }
      return r.json();
    });
  }

  function aplicar_cupon() {
    var input = cupon_el('.cupon-input');
    if (!input) return;
    var code = String(input.value || '').trim();
    if (!code) { input.focus(); return; }
    var existentes = window.odisCupones || [];
    if (existentes.some(function (c) { return c.toUpperCase() === code.toUpperCase(); })) {
      input.value = '';
      rmC(cupon_el('.cupon'), 'open');
      return;
    }
    addC(cupon_el('.cupon'), 'loading');
    rmC(cupon_el('.cupon-error'), 'show');
    rmC(cupon_el('.cupon-info'), 'show');
    post_cupones(existentes.concat([code]))
      .then(function (data) {
        var entrada = (data.discount_codes || []).find(function (d) { return d.code.toUpperCase() === code.toUpperCase(); });
        if (!entrada || !entrada.applicable) {
          // No dejar el código rechazado pegado al carrito
          return post_cupones(existentes).then(function () {
            rmC(cupon_el('.cupon'), 'loading');
            cupon_msg('error', 'El código no es válido o no aplica a tu carrito');
          });
        }
        var sinEfecto = (data.total_discount || 0) === 0;
        return refrescar_drawer().then(function () {
          if (sinEfecto) cupon_msg('info', 'Cupón aplicado: lo verás reflejado en el checkout');
        });
      })
      .catch(function (e) {
        rmC(cupon_el('.cupon'), 'loading');
        if (e && e.sesionExpirada) {
          cupon_msg('error', 'La sesión expiró: recarga la página e intenta de nuevo');
        } else {
          cupon_msg('error', 'No se pudo aplicar el cupón, intenta de nuevo');
        }
      });
  }

  function quitar_cupon(code) {
    var restantes = (window.odisCupones || []).filter(function (c) {
      return c.toUpperCase() !== String(code || '').toUpperCase();
    });
    addC(cupon_el('.cupon'), 'loading');
    post_cupones(restantes)
      .catch(function () {})
      .then(function () { return refrescar_drawer(); });
  }

  // Repintar barra/cupón cuando Dawn re-renderiza el contenido del drawer
  var pintarTimer = null;
  function observar_cart_drawer() {
    var cont = $q('#CartDrawer');
    if (!cont || cont.dataset.odisObs) return;
    cont.dataset.odisObs = '1';
    new MutationObserver(function () {
      if (pintando) return;
      clearTimeout(pintarTimer);
      pintarTimer = setTimeout(function () { refrescar_total_carrito(); }, 200);
    }).observe(cont, { childList: true, subtree: true });
  }

  // ===== Eventos (delegados en document: sobreviven cualquier re-render) =====
  document.addEventListener('click', function (e) {
    var t = e.target;


    // Click fuera del panel abierto: cerrarlo (el overlay del drawer, la página, etc.)
    var panelAbierto = raiz() && raiz().classList.contains('show');
    if (panelAbierto && t.closest && !t.closest(RAIZ) && !t.closest('.odis-pago-trigger') && !t.closest('.dir-modal')) {
      cerrar_pago_step();
    }

    // Modal de dirección del badge de envío
    if (t.closest && t.closest('.dir-modal')) {
      if (t.closest('.cerrar-modal')) { cerrar_dir_modal(); return; }
      if (t.closest('.modal-listo')) {
        if (direccion_falta_numero(window.miniCartDireccion)) {
          addC(modal_el('.modal-numero'), 'show');
          var cajaM = modal_el('.dir-modal-caja');
          addC(cajaM, 'shake');
          setTimeout(function () { rmC(cajaM, 'shake'); }, 500);
          return;
        }
        cerrar_dir_modal();
        return;
      }
      if (t.classList && t.classList.contains('dir-modal')) cerrar_dir_modal();
      return;
    }

    var trigger = t.closest && t.closest('.odis-pago-trigger');
    if (trigger) {
      var cd = $q('cart-drawer');
      if (cd && cd.classList.contains('is-empty')) { e.preventDefault(); return; }
      if (!raiz()) return; // sin panel (setting off con href /checkout): dejar navegar
      e.preventDefault();
      abrir_pago_step();
      return;
    }
    // Cupón y CTA de dirección del drawer (paso 1)
    if (t.closest && t.closest('#CartDrawer')) {
      if (t.closest('.cupon-toggle')) {
        var cup = cupon_el('.cupon');
        if (cup) {
          togC(cup, 'open', !cup.classList.contains('open'));
          rmC(cupon_el('.cupon-error'), 'show');
          rmC(cupon_el('.cupon-info'), 'show');
          if (cup.classList.contains('open')) setTimeout(function () { var i = cupon_el('.cupon-input'); if (i) i.focus(); }, 200);
        }
        return;
      }
      if (t.closest('.cupon-aplicar')) { aplicar_cupon(); return; }
      var quitarPill = t.closest('.cupon-pills .quitar');
      if (quitarPill) { quitar_cupon(quitarPill.parentElement.dataset.code); return; }
      if (t.closest('.envio-badge .dir-cta') || t.closest('.envio-badge .cambiar-comuna')) { abrir_dir_modal(); return; }
    }

    if (!t.closest || !t.closest(RAIZ)) return;

    if (t.closest('.pago-volver')) { cerrar_pago_step(); return; }
    if (t.closest('.pago-continuar')) { continuar_pago(); return; }
    var cambiarDir = t.closest('.direccion-guardada .cambiar');
    if (cambiarDir) {
      window.miniCartDireccion = null;
      pago_storage_guardar({ dir: null, dirTexto: '' });
      rmC(pq('.direccion-guardada'), 'show');
      rmC(pq('.direccion-ok'), 'show');
      rmC(pq('.direccion-numero'), 'show');
      rmC(pq('.direccion-msg'), 'show');
      var slot = pq('.direccion-slot');
      if (slot) slot.classList.remove('oculto', 'valido', 'invalido');
      actualizar_barra_envio();
      try { $q(RAIZ + ' .direccion-slot gmp-place-autocomplete').focus(); } catch (err) {}
      return;
    }
    var cambiarFact = t.closest('.fact-guardada .cambiar');
    if (cambiarFact) {
      window.miniCartDirFact = null;
      pago_storage_guardar({ dirFact: null, dirFactTexto: '' });
      rmC(pq('.fact-guardada'), 'show');
      rmC(pq('.fact-ok'), 'show');
      rmC(pq('.fact-numero'), 'show');
      rmC(pq('.fact-msg'), 'show');
      var fslot = pq('.fact-slot');
      if (fslot) fslot.classList.remove('oculto', 'valido', 'invalido');
      try { $q(RAIZ + ' .fact-slot gmp-place-autocomplete').focus(); } catch (err) {}
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'minicart_doctype') { actualizar_doctype_ui(t.value); return; }
    if (t.id === 'minicart-sin-numero') {
      var dir = window.miniCartDireccion;
      if (!dir) return;
      dir.sinNumero = t.checked;
      togC(pq('.direccion-numero'), 'sin', t.checked);
      var chkModal = $q('#minicart-modal-sin-numero');
      if (chkModal) chkModal.checked = t.checked;
      actualizar_direccion_texto();
      return;
    }
    if (t.id === 'minicart-modal-sin-numero') {
      var dirM = window.miniCartDireccion;
      if (!dirM) return;
      dirM.sinNumero = t.checked;
      var chkPanel = $q('#minicart-sin-numero');
      if (chkPanel) chkPanel.checked = t.checked;
      togC(pq('.direccion-numero'), 'sin', t.checked);
      actualizar_direccion_texto();
      mostrar_modal_ui();
      return;
    }
    if (t.id === 'minicart-fact-sin-numero') {
      var df = window.miniCartDirFact;
      if (!df) return;
      df.sinNumero = t.checked;
      togC(pq('.fact-numero'), 'sin', t.checked);
      actualizar_fact_texto();
      return;
    }
    if (t.id === 'minicart-misma-dir') {
      togC(pq('.campo-fact-dir'), 'distinta', !t.checked);
      rmC(pq('.fact-msg'), 'show');
      pago_storage_guardar({ factMisma: t.checked });
      if (!t.checked) init_direccion_google_fact();
      return;
    }
    if (t.id === 'minicart-terminos' && t.checked) {
      rmC(pq('.terminos-msg'), 'show');
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.id === 'minicart-rut') { validar_rut_input(t); return; }
    if (['minicart-razon', 'minicart-giro', 'minicart-depto', 'minicart-nombre', 'minicart-apellido'].indexOf(t.id) !== -1) {
      togC(t, 'valido', t.value.trim().length > 0);
      rmC(t, 'invalido');
      var m = t.parentElement && t.parentElement.querySelector('.campo-error');
      rmC(m, 'show');
      return;
    }
    if (t.id === 'minicart-correo' || t.id === 'minicart-telefono') {
      var v = t.value.trim();
      var ok = t.id === 'minicart-correo' ? validar_correo(v) : validar_telefono(v);
      togC(t, 'valido', v.length > 0 && ok);
      rmC(t, 'invalido');
      var m2 = t.parentElement && t.parentElement.querySelector('.campo-error');
      rmC(m2, 'show');
    }
  });

  document.addEventListener('blur', function (e) {
    var t = e.target;
    if (!t || (t.id !== 'minicart-correo' && t.id !== 'minicart-telefono')) return;
    var v = t.value.trim();
    if (!v) return;
    var ok = t.id === 'minicart-correo' ? validar_correo(v) : validar_telefono(v);
    if (!ok) {
      addC(t, 'invalido');
      var m = t.parentElement && t.parentElement.querySelector('.campo-error');
      addC(m, 'show');
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t.classList && t.classList.contains('cupon-input')) {
      e.preventDefault();
      aplicar_cupon();
      return;
    }
    if (t.closest && (t.closest('.envio-badge .dir-cta') || t.closest('.envio-badge .cambiar-comuna'))) {
      e.preventDefault();
      abrir_dir_modal();
      return;
    }
    if (t.closest && t.closest('.dir-modal .cerrar-modal')) {
      e.preventDefault();
      cerrar_dir_modal();
      return;
    }
    if (t.closest && t.closest(RAIZ + ' .pago-body') && t.matches('input[type="text"]')) {
      e.preventDefault();
      continuar_pago();
    } else if (t.closest && (t.closest(RAIZ + ' .pago-volver'))) {
      e.preventDefault();
      cerrar_pago_step();
    }
  });

  // Reset del spinner al volver del checkout (bfcache)
  window.addEventListener('pageshow', function () {
    var step = raiz();
    if (step) rmC(step, 'loading');
  });

  // El panel sigue el ciclo de vida del drawer: si el drawer se cierra
  // (overlay, tecla Esc, botón ✕), el paso de pago se cierra con él.
  function observar_drawer() {
    var cd = $q('cart-drawer');
    if (!cd || cd.dataset.odisPagoHooked) return;
    cd.dataset.odisPagoHooked = '1';
    new MutationObserver(function () {
      if (!cd.classList.contains('active')) { cerrar_pago_step(); cerrar_dir_modal(); }
    }).observe(cd, { attributes: true, attributeFilter: ['class'] });
  }
  function init_drawer_hooks() {
    observar_drawer();
    observar_cart_drawer();
    refrescar_total_carrito();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init_drawer_hooks);
  else init_drawer_hooks();

  // Total del carrito al día si Dawn publica cambios (pubsub de Dawn)
  if (typeof subscribe === 'function') {
    try {
      var evt = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) ? PUB_SUB_EVENTS.cartUpdate : 'cart-update';
      subscribe(evt, function () { refrescar_total_carrito(); });
    } catch (e) {}
  }
})();
